import Carousel from './src/Carousel';
import './index.scss';

export default Carousel;

